<script setup lang="ts">
import { useRoute } from '#app'
import AppButton from '../AppButton.vue'

const props = defineProps<{
  open?: boolean
}>()

const route = useRoute()
const emit = defineEmits(['hide', 'showMenu1', 'showMenu2', 'showMenu3', 'showMenu4'])
</script>

<template>
  <div
    class="h-auto max-h-[calc(100svh-72px)] xl:max-h-none bg-white row-start-1 row-end-1 col-start-1 col-end-1 px-xl xl:py-15 flex flex-col gap-4 transform-gpu duration-400 ease-in-out z-80 overflow-y-auto items-stretch"
    :class="props.open ? 'translate-y-0 pointer-events-auto' : '-translate-y-full pointer-events-none'"
  >
    <div
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('prywatny-dom-opieki') ? 'bg-background-2' : ''"
      @click="emit('showMenu1');"
    >
      <span class="text-Tekst text-nowrap">Prywatny dom opieki</span>
    </div>
    <div
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('sprzedaz-mieszkan') ? 'bg-background-2' : ''"
      @click="emit('showMenu2');"
    >
      <span class="text-Tekst text-nowrap">Sprzedaż mieszkań</span>
    </div>
    <div
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('wynajem-mieszkan') ? 'bg-background-2' : ''"
      @click="emit('showMenu3');"
    >
      <span class="text-Tekst text-nowrap">Wynajem mieszkań</span>
    </div>

    <NuxtLink
      to="/prywatny-dom-opieki/#restauracja-i-bistro"
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('restauracja-i-bistro') ? 'bg-background-2' : ''"
      @click="emit('hide')"
    >
      <span class="text-Tekst text-nowrap">Restauracja & Bistro</span>
    </NuxtLink>
    <div
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('o-nas') ? 'bg-background-2' : ''"
      @click="emit('showMenu4');"
    >
      <span class="text-Tekst text-nowrap">O nas</span>
    </div>
    <NuxtLink
      to="/blog/"
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('blog') ? 'bg-background-2' : ''"
      @click="emit('hide')"
    >
      <span class="text-Tekst text-nowrap">Blog</span>
    </NuxtLink>
    <NuxtLink
      to="/kontakt/"
      class="px-4 py-2.5 rounded-full transform-gpu transition-all duration-200 hover:bg-background-2 cursor-pointer"
      :class="route.path.includes('kontakt') ? 'bg-background-2' : ''"
      @click="emit('hide')"
    >
      <span class="text-Tekst text-nowrap">Kontakt</span>
    </NuxtLink>
    <CmsLink
      v-slot="{ link }"
      :cms-data-path="['global', 'component_data', 'navbar_mobile_menu_btn_1']"
      global
    >
      <AppButton
        :href="link?.href"
        :target="link?.target"
        button-theme="Primary"
        @click="emit('hide')"
      >
        <span class="text-nowrap! link-text">
          {{ link?.link_text ?? 'Lorem Ipsum' }}
        </span>
      </AppButton>
    </CmsLink>
    <CmsLink
      v-slot="{ link }"
      :cms-data-path="['global', 'component_data', 'navbar_mobile_menu_btn_2']"
      global
    >
      <AppButton
        :href="link?.href"
        :target="link?.target"
        button-theme="Secondary"
        @click="emit('hide')"
      >
        <span class="text-nowrap! link-text">
          {{ link?.link_text ?? 'Lorem Ipsum' }}
        </span>
      </AppButton>
    </CmsLink>
  </div>
</template>
